import { h, Component } from 'preact';
import isAllowed from '../../';

/**
 * This component will only render its children if the supplied restriction condition
 * resolves true via isAllowed(condition).
 *
 * EG: <Restriction condition="authn">{//only renders if user is logged in}</Restriction>
 *
 * This component supports AND[] and OR{or:[]} as values for condition.
 *
 */
export default class Restriction extends Component {

	checkRenderable() {
		let { condition } = this.props,
			canRenderCheck = condition ? isAllowed(condition, this.props, this.context) : true;

		if (canRenderCheck === false) {
			this.setState({ canRender: false });
			return;
		}
		else if (canRenderCheck.then) {
			this.setState({ checkingRenderability: true });
			canRenderCheck.then(canRender => {
				this.setState({ canRender, checkingRenderability: false });
				if (this.props.onResolved && canRender) this.props.onResolved();
			});
			return;
		}
		if (this.props.onResolved) this.props.onResolved();
		this.setState({ canRender: true });
	}

	componentWillMount(){
		this.checkRenderable();
	}

	render({ children }, { checkingRenderability, canRender }) {
		if (checkingRenderability || !canRender) return null;
		return children && children[0];
	}

}


// WEBPACK FOOTER //
// ../node_modules/@cube/restrictions/src/components/restriction/index.js